import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPl = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 10",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 16,
		height: 10,
		fill: "#DC143C"
	}), /* @__PURE__ */ _jsx("rect", {
		width: 16,
		height: 5,
		fill: "#fff"
	})]
});
export default SvgPl;
